module.exports = __webpack_public_path__ + "static/media/mobile_3.28b7989f.jpg";